import PageHeader from "@/components/PageHeader";
import ServicesGrid from "@/components/ServicesGrid";
import CTABand from "@/components/CTABand";

export default function Services() {
  return (
    <div data-testid="page-services">
      <PageHeader
        overline="Services"
        title="Six divisions."
        italic="One coordinated promise."
        description="From the first hospital discharge to long-term independence at home, our service lines work together to deliver the right care at the right time — without forcing families to navigate fragmented providers."
      />
      <ServicesGrid heading={false} />
      <CTABand />
    </div>
  );
}
